import { Box, Typography } from "@mui/material"
import { colorsConfig } from "../../../../../../../config/colors.config"
import { useFlowHubAuth } from "@features/FlowHub/hooks/useFlowHubAuth"

export const FlowHubHeroHeader = () => {
    const { getUserName } = useFlowHubAuth();

    return (
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            gap: 0.625,
            justifyContent: "center",
            alignItems: "center",
            py: { xs: 1.6, xl: 4.4 },
            px: 2,
        }}>
            <Typography sx={{
                color: colorsConfig.textSecondary,
                fontSize: { xs: "1rem", xl: "1.18rem" },
                fontWeight: 400
            }}>
                {getUserName()}
            </Typography>
            <Typography sx={{
                color: colorsConfig.textPrimary,
                fontSize: { xs: "1.75rem", md: "2.4rem", xl: "3.35rem" },
                fontWeight: 600
            }}>
                What do you want to do today?
            </Typography>
            <Box sx={{
                width: "fit-content",
                textAlign: "center",
            }}>
                <Typography sx={{
                    color: colorsConfig.textSecondary,
                    fontSize: { xs: "0.95rem", xl: "1.16rem" },
                    fontWeight: 400
                }}>
                    Discover services, manage your business, and find job opportunities in your area.
                </Typography>
            </Box>
        </Box>
    )
}
